// extracted by mini-css-extract-plugin
export default {"cover_card":"Carousel_cover_card__RujXK","cover_caption":"Carousel_cover_caption__GozyQ","cover_thumb":"Carousel_cover_thumb__unhNr","mobile_drag":"Carousel_mobile_drag__lLybS"};